import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_REVIEW_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
};
